// ── Formatters (unchanged from the original app — kept here so the
//    ui package is self-contained). Import from your existing utils
//    instead if you already have them.
export const fmt_n    = (v: number) => !v ? '0' : v >= 1e6 ? (v/1e6).toFixed(1)+'M' : v >= 1e3 ? (v/1e3).toFixed(0)+'K' : String(Math.round(v));
export const fmt_k    = (v: number) => !v ? '₺0' : v >= 1e6 ? '₺'+(v/1e6).toFixed(1)+'M' : v >= 1e3 ? '₺'+(v/1e3).toFixed(0)+'K' : '₺'+Math.round(v);
export const fmt_roas = (v: number) => v ? v.toFixed(2)+'x' : '—';
export const fmt_sec  = (v: number) => { if(!v) return '0:00'; const m=Math.floor(v/60), s=Math.round(v%60); return `${m}:${String(s).padStart(2,'0')}`; };
export const fmt_pct  = (curr: number, prev: number) => { if(!prev||!curr) return '—'; const p=((curr-prev)/prev)*100; return (p>=0?'+':'')+p.toFixed(1)+'%'; };
export const pct_dir  = (curr: number, prev: number): 'up'|'down'|'flat' => (!prev||!curr) ? 'flat' : curr>=prev ? 'up' : 'down';

// ROAS segmentasyonu (Dashboard/Optimizasyon) için "bilinirlik/awareness" kampanya
// sınıflandırması — tek bir hesaba/markaya özel değil, TÜM müşteriler için geçerli bir
// tool özelliği (kullanıcı isteği, 2026-09-13). "brand"/"branding"/"brd" BİLEREK burada
// YOK — backend'in optimize_router.py'deki BRAND_KEYWORDS'ünden (öneri motorunun brand
// kampanyalarını negatif-kelime/pause gibi otomatik aksiyonlardan koruması için, o context
// farklı) kasıtlı olarak farklı: canlı Denim Trip verisiyle test edilirken "SRC - Denim Trip
// Branding" adında (TARGET_IMPRESSION_SHARE, markalı arama) 17.56× ROAS'lı GERÇEK bir satış
// kampanyası bulundu — "brand"/"branding" kelimesi isimde geçse de bu kampanya satış
// odaklı, gerçek ROAS'a dahil edilmeli. Burada sadece gerçekten dönüşüm beklenmeyen
// kampanya TİPLERİ (Google: Demand Gen, YouTube; Meta: awareness/video/traffic/post boost
// objektifleri) hariç tutuluyor — isimde geçen "brand" kelimesi değil.
// "video view" ayrıca eklendi (kullanıcı isteği, 2026-09-13) — gerçek Denim Trip verisinde
// "Video View - Denim Trip Generic" adında bir YouTube/video-izlenme kampanyası "youtube"
// kelimesini içermediği için filtreden kaçıyordu, Marka Dışı (satış odaklı) ROAS'ı
// yanlışlıkla aşağı çekiyordu.
export const AWARENESS_KEYWORDS = ['demand gen', 'youtube', 'video view', 'awareness', 'bilinirlik', 'etkileşim', 'post boost', 'boost', 'traffic'];
export const isBrandCampaign = (name?: string) => {
  const nl = (name || '').toLowerCase();
  return AWARENESS_KEYWORDS.some(k => nl.includes(k));
};
